"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* eslint-disable react/prop-types */
const React = __importStar(require("react"));
const clsx_1 = require("clsx");
const prefix = 'tk-button';
exports.Button = React.forwardRef((_a, ref) => {
    var { children, className, iconButton = false, variant = 'primary', loading = false, disabled = false, type = 'button', size = 'medium', iconRight, iconLeft } = _a, rest = __rest(_a, ["children", "className", "iconButton", "variant", "loading", "disabled", "type", "size", "iconRight", "iconLeft"]);
    const classes = (0, clsx_1.clsx)(className, prefix, `${prefix}--${variant}`, `${prefix}--${size}`, {
        [`${prefix}--icon`]: iconButton,
        loading: loading,
        [`${prefix}--icon-left`]: iconLeft,
        [`${prefix}--icon-right`]: iconRight,
    });
    if (variant === 'destructive') {
        console.warn("The button variant: 'destructive' will be deprecated.\n Please use: 'primary-destructive' instead");
    }
    return ((0, jsx_runtime_1.jsxs)("button", Object.assign({ "aria-label": loading ? 'loading' : null, className: classes, disabled: loading || disabled, ref: ref, style: { color: loading ? 'transparent' : null }, type: type }, rest, { children: [loading && ((0, jsx_runtime_1.jsx)("i", { className: "tk-button-icon--loading animate-spin tk-icon-loading" })), iconLeft, children, iconRight] })));
});
exports.Button.displayName = 'Button';
exports.default = exports.Button;
